import React from 'react';
import {SdkComponent} from "../sdk/sdk.component";
import {ClockComponentBox} from "./boxes/clock.component.box";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";


interface ClockComponentProps {
  format?: string
}

export class ClockComponent extends OrbitComponent<ClockComponentProps>{
  render() {
    const sdkProps = {
      datetime: this.props.format
    };

    return (
        <SdkComponent
            box={ClockComponentBox}
            sdkProps={sdkProps}
            className={"cy-clock-component"}
            componentId={'clock'}
        />
    );
  }
}
